import { memo } from "react";
import { StepComponentProps, StepRegistryEntry } from "./types";
import { DocumentTypeRenderer } from "../BinaryContent/DocumentTypeRenderer";
import { titleCase } from "../../../../utils";

const DefaultStep = memo((props: StepComponentProps) => {
  const {
    stepConfig,
    documents,
    requestId,
    companyRole,
    canEdit,
    comments,
    addComment,
    userInfo,
    isMobile,
    statusesConfig,
    onRefreshDocuments,
    expandedDocumentType,
  } = props;

  const title = stepConfig.title || titleCase(stepConfig.name || stepConfig.type);

  if (documents.length === 0) {
    return null;
  }

  return (
    <>
      {documents.map((doc) => (
        <DocumentTypeRenderer
          key={doc.document.documentId || doc.document.documentType}
          document={doc}
          requestId={requestId}
          title={title}
          stepType={stepConfig.type}
          configFields={stepConfig.fields}
          companyRole={companyRole}
          canEdit={canEdit}
          comments={comments}
          addComment={addComment}
          userInfo={userInfo}
          isMobile={isMobile}
          statusesConfig={statusesConfig}
          onRefreshDocuments={onRefreshDocuments}
          defaultExpanded={
            expandedDocumentType === doc.document.documentType
          }
        />
      ))}
    </>
  );
});

export const DefaultEntry: StepRegistryEntry = {
  StepComponent: DefaultStep,
};
